import FileUpload from "cpl-react-common/components/Inputs/fileUpload";
import { ExistingFile } from "cpl-react-common/components/Inputs/fileUpload/components/FilePreview";

type CPLFileUploadProps = {
  "data-test-id"?: string;
  updateNewFiles?: (files: File[]) => void;
  updateDeletedFiles?: (files: ExistingFile[]) => void;
  displayError?: (error: string) => void;
  downloadFile?: (file: ExistingFile) => Promise<File>;
  disabled?: boolean;
  initialFiles?: ExistingFile[];
  maximumNumberOfFiles?: number;
  acceptedFileTypes?: string[];
  maximumFileSizeBytes?: number;
  maximumTotalUploadBytes?: number;
  fileRestrictionsText?: string;
  loading?: boolean;
  emptyUploaderHeightPx?: number;
};

export const CPLFileUpload: React.FC<CPLFileUploadProps> = ({
  "data-test-id": testId,
  updateNewFiles,
  updateDeletedFiles,
  displayError,
  downloadFile,
  disabled,
  initialFiles,
  maximumNumberOfFiles,
  maximumFileSizeBytes,
  maximumTotalUploadBytes,
  fileRestrictionsText,
  loading,
  acceptedFileTypes,
}) => {
  return (
    <FileUpload
      data-test-id={testId}
      updateNewFiles={updateNewFiles}
      updateDeletedFiles={updateDeletedFiles}
      displayError={displayError}
      downloadFile={downloadFile}
      disabled={disabled}
      initialFiles={initialFiles}
      maximumNumberOfFiles={maximumNumberOfFiles}
      maximumFileSizeBytes={maximumFileSizeBytes}
      maximumTotalUploadBytes={maximumTotalUploadBytes}
      fileRestrictionsText={fileRestrictionsText}
      loading={loading}
      optimiseForLargerScreens
      acceptedFileTypes={acceptedFileTypes}
    />
  );
};
